import { useDispatch, useSelector } from 'react-redux';

import {
  Popover,
  PopoverTrigger,
  Button,
  PopoverButtonGroup,
  Portal,
  PopoverBody,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
} from '@frontend/components';

import { groupMemberChangeUserGroup } from 'modules/common/userGroupManagement/data/actions';
import { acknowledgeNotification } from 'modules/notifications/data/actions.js';
import type { Notification, GroupMember } from 'modules/notifications/types';

import { getAvailableGroupMembers } from 'store/session/selectors';

type ToggleState = React.Dispatch<React.SetStateAction<boolean>>;

type NotificationPopoverProps = {
  children: React.ReactNode;
  toggleOpen: ToggleState;
  isOpen: boolean;
  nextUrl: string;
  notification: Notification;
};

type RequestedGroupMember = GroupMember | undefined;

const NotificationsPopover = ({
  children,
  toggleOpen,
  isOpen,
  nextUrl,
  notification,
}: NotificationPopoverProps) => {
  const dispatch = useDispatch();

  const availableGroupMembers = useSelector(getAvailableGroupMembers);

  const requestedGroupMember: RequestedGroupMember = availableGroupMembers.find(
    (groupMember: GroupMember) => groupMember.id === notification.groupMemberId,
  );

  const handleSwitchAndRedirect = () => {
    if (requestedGroupMember) {
      dispatch(
        groupMemberChangeUserGroup.request({
          groupMemberId: requestedGroupMember['id'],
          nextUrl,
        }),
      );
      dispatch(acknowledgeNotification.request({ notification }));
    }
  };

  return (
    <Popover
      size="md"
      placement="auto"
      isOpen={isOpen}
      onClose={() => toggleOpen(false)}
    >
      <PopoverTrigger>{children}</PopoverTrigger>
      <Portal>
        <PopoverContent>
          <PopoverHeader>Change active organization?</PopoverHeader>
          <PopoverBody>
            Changing your active organization will affect all tabs in your
            browser.
          </PopoverBody>
          <PopoverFooter>
            <PopoverButtonGroup>
              <Button variant="secondary" onClick={() => toggleOpen(false)}>
                Cancel
              </Button>
              <Button
                isDisabled={!requestedGroupMember ? true : false}
                onClick={() => handleSwitchAndRedirect()}
              >
                Confirm
              </Button>
            </PopoverButtonGroup>
          </PopoverFooter>
        </PopoverContent>
      </Portal>
    </Popover>
  );
};

export default NotificationsPopover;
